// lib/mpd.js
// Limpia MPD de entradas master si hiciera falta
export function sanitizeMpd(xml, evt) {
  if (!xml) return xml;
  try {
    const re = new RegExp(
      `<AdaptationSet[\\s\\S]*?<BaseURL>[^<]*/${evt}/master/[^<]*</BaseURL>[\\s\\S]*?</AdaptationSet>`,
      'gi'
    );
    return xml.replace(re, '').trim();
  } catch {
    return xml;
  }
}

function isVideoRole(role) {
  const r = String(role || '').toLowerCase();
  return r === 'video' || r === 'cam';
}
function isAudioRole(role) {
  return String(role || '').toLowerCase() === 'audio';
}

function extractSuffix(camName) {
  const m = String(camName || '').match(/(\d+)$/);
  return m ? m[1] : camName; // si no hay dígitos, usar nombre completo para ordenar
}

function buildVideoAdaptationSet(inst, id) {
  const baseUrl = `../${inst.camName}/`;
  return `    <AdaptationSet id="${id}" contentType="video" startWithSAP="1" segmentAlignment="true" bitstreamSwitching="true" frameRate="30/1" maxWidth="3840" maxHeight="2160" par="16:9">\n      <BaseURL>${baseUrl}</BaseURL>\n      <Representation id="0" mimeType="video/mp4" codecs="avc1.640033" bandwidth="20000000" width="3840" height="2160" sar="1:1">\n        <SegmentTemplate timescale="1000000" duration="1000000" availabilityTimeOffset="10.0" availabilityTimeComplete="false" initialization="init-stream$RepresentationID$.m4s" media="chunk-stream$RepresentationID$-$Number%05d$.m4s" startNumber="1" />\n      </Representation>\n    </AdaptationSet>`;
}
function buildAudioAdaptationSet(inst, id, label) {
  const baseUrl = `../${inst.camName}/`;
  return `    <AdaptationSet id="${id}" contentType="audio" lang="${label || 'und'}" startWithSAP="1" segmentAlignment="true" bitstreamSwitching="true">\n      <BaseURL>${baseUrl}</BaseURL>\n      <Representation id="0" mimeType="audio/mp4" codecs="mp4a.40.2" bandwidth="320000" audioSamplingRate="48000">\n        <AudioChannelConfiguration schemeIdUri="urn:mpeg:dash:23003:3:audio_channel_configuration:2011" value="2" />\n        <SegmentTemplate timescale="1000000" duration="1000000" availabilityTimeOffset="10.0" availabilityTimeComplete="false" initialization="init-stream$RepresentationID$.m4s" media="chunk-stream$RepresentationID$-$Number%05d$.m4s" startNumber="1" />\n      </Representation>\n    </AdaptationSet>`;
}

// Empareja camXX con audioXX (mismo sufijo) y genera AdaptationSets: ahora primero todos los video y luego todos los audio
export function generateMpdString(eventKey, instances, publish, avail, camLabels = {}) {
  const mediaInstances = (instances || []).filter(i => (i.role || '').toLowerCase() !== 'master');
  const videos = mediaInstances.filter(i => isVideoRole(i.role));
  const audios = mediaInstances.filter(i => isAudioRole(i.role));

  const extractSuffix = (camName) => {
    const m = String(camName || '').match(/(\d+)$/);
    return m ? m[1] : camName;
  };

  const sortFn = (a,b) => {
    const sa = extractSuffix(a.camName);
    const sb = extractSuffix(b.camName);
    const na = Number(sa), nb = Number(sb);
    if (!isNaN(na) && !isNaN(nb)) return na - nb;
    return String(sa).localeCompare(String(sb), undefined, { numeric:true, sensitivity:'base' });
  };

  videos.sort(sortFn);
  audios.sort(sortFn);

  let adaptationId = 0;
  const parts = [];
  for (const v of videos) parts.push(buildVideoAdaptationSet(v, adaptationId++));
  for (let i = 0; i < audios.length; i++) {
    const a = audios[i];
    const label = (camLabels && camLabels[a.instanceId]) || `Audio ${i + 1}`;
    parts.push(buildAudioAdaptationSet(a, adaptationId++, label));
  }

  const adaptations = parts.join('\n');

  return `<?xml version="1.0" encoding="utf-8"?>\n<MPD xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"\n     xmlns="urn:mpeg:dash:schema:mpd:2011"\n     xmlns:xlink="http://www.w3.org/1999/xlink"\n     xsi:schemaLocation="urn:mpeg:DASH:schema:MPD:2011 http://standards.iso.org/ittf/PubliclyAvailableStandards/MPEG-DASH_schema_files/DASH-MPD.xsd"\n     profiles="urn:mpeg:dash:profile:isoff-live:2011"\n     type="dynamic"\n     minimumUpdatePeriod="PT2S"\n     availabilityStartTime="${avail}"\n     publishTime="${publish}"\n     timeShiftBufferDepth="PT20M0.0S"\n     maxSegmentDuration="PT1.0S"\n     minBufferTime="PT2.0S">\n  <ProgramInformation></ProgramInformation>\n  <ServiceDescription id="0"><Latency target="5000"/></ServiceDescription>\n  <Period id="0" start="PT0.0S">\n${adaptations}\n  </Period>\n  <UTCTiming schemeIdUri="urn:mpeg:dash:utc:http-xsdate:2014" value="https://time.akamai.com/?iso"/>\n</MPD>`;
}
